export function setAuthState(state: string, codeVerifier: string) {
  const len = localStorage.length;

  const previousKeys = [];
  for (let index = 0; index < len; index++) {
    const key = localStorage.key(index);
    if (key && key.indexOf('pkce.') === 0) {
      previousKeys.push(key);
    }
  }

  previousKeys.forEach((key) => localStorage.removeItem(key));

  localStorage.setItem(`pkce.${state}`, codeVerifier);
}
